<template>
  <div id="globalNewParams" class="warp">
    <!-- 头部搜索栏 -->
    <div>
      <div class="head_search">
        <div style="margin-right: 20px">
          <el-button
            type="primary"
            size="mini"
            class="edit-button"
            @click="getList"
          >筛选</el-button>
          <el-button
            type="warning"
            size="mini"
            @click="resetEvent()"
          >重置</el-button>
        </div>
        <div class="item_warp">
          <label style="width: 54px">手机号</label>
          <el-input
            v-model="userPhone"
            placeholder="请输入手机号"
            style="width: 150px"
            size="mini"
            clearable
          />
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <div class="table_warp">
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="userTable"
        border
        style="width: 1531px"
        height="calc(100vh - 320px )"
        size="mini"
      >
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="userPhone" label="用户" width="300">
          <template slot-scope="scope">
            <div>{{ scope.row.userPhone }}({{ scope.row.userName }})</div>
          </template>
        </el-table-column>
        <el-table-column prop="crmTicketName" label="票券名称" width="200" />
        <el-table-column prop="crmTicketNo" label="票券号码" width="200" />
        <el-table-column label="有效时间" width="300">
          <template slot-scope="scope">
            <div v-if="scope.row.effectiveType === 1">
              {{ scope.row.effectiveStartTime }} ~
              {{ scope.row.effectiveEndTime }}
            </div>
            <div v-if="scope.row.effectiveType === 2">
              {{ scope.row.effectiveDayCount }}天
            </div>
          </template>
        </el-table-column>
        <el-table-column label="可分享次数" width="100">
          <template slot-scope="scope">
            {{ scope.row.share_count }} 次
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <div :style="{ color: statusColorOp[scope.row.status] }">
              {{ statusOp[scope.row.status] }}
            </div>
          </template>
        </el-table-column>

        <!-- 创建时间-->
        <el-table-column prop="createdAt" label="创建时间" width="200">
          <template slot-scope="scope">
            {{
              $parseTime(
                new Date(scope.row.createdAt),
                "{y}-{m}-{d} {h}:{i}:{s}"
              )
            }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNumber"
      :limit.sync="pageSize"
      :page-sizes="[2, 5, 10, 20, 50]"
      @pagination="next()"
    />
  </div>
</template>
<script>
import Pagination from '@/components/Pagination' // 引入分页器
import { getTicketRecordList } from '@/api/ticketMan.js'

export default {
  name: 'GlobalNewParams',
  components: { Pagination },
  data() {
    return {
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      userTable: [],
      value1: '',
      dialogVisible: false,
      questionList: [],
      formData: {
        queNo: '',
        queName: '',
        count: 0,
        queTitle: ''
      },
      userPhone: '',
      userName: '',
      dateTime: '',
      loading: false,
      // 状态（0已使用 1待使用 2 已过期）
      statusOp: ['已使用', '待使用', '已过期'],
      statusColorOp: ['#67C23A', '#FF9900', '#e74c3c']
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    getList() {
      this.loading = true
      var params = {
        pageNum: this.pageNumber,
        pageSize: this.pageSize,
        userPhone: this.userPhone
      }
      getTicketRecordList(params)
        .then((res) => {
          console.log(res)
          this.userTable = res.rows
          this.total = res.count
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 下一页或刷新
    next() {
      this.$refs.gridTable.bodyWrapper.scrollTop = 0
      this.getList()
    },
    select() {
      this.pageNumber = 1
      this.getList()
    },
    // 关闭添加弹窗
    handleClose() {
      this.initForm()
    },
    initForm() {
      this.formData = {
        queNo: '',
        queName: '',
        count: 0,
        queTitle: ''
      }
    },
    // checkEvent(item) {
    //   this.formData = { ...this.formData, ...item }
    //   recordDetail({ parentId: item.id }).then((res) => {
    //     this.dialogVisible = true
    //     this.questionList = res
    //     console.log('this.questionList', this.questionList)
    //   })
    // },
    resetEvent() {
      this.userName = ''
      this.userPhone = ''
      this.dateTime = ''
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
#globalNewParams {
  .el-image {
    position: relative;
    display: inline-block;
    overflow: hidden;
    width: 100px;
    height: 100px;
  }

  .head_search {
    display: flex;
    width: 100%;
    margin-bottom: 20px;

    .item_warp {
      display: flex;

      .el-checkbox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
      }

      label {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #525252;
        font-weight: 400;
      }
    }
  }

  .green {
    color: #00c759;
  }

  .red {
    color: rgb(255, 62, 51);
  }

  .el-tag + .el-tag {
    margin-left: 3px;
  }

  .button-new-tag {
    margin-left: 10px;
    margin-top: 5px;
    height: 25px;
    line-height: 25px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .zhi {
    margin: 0 0 10px 0;
    display: flex;
    align-items: center;
  }

  .el-tag--mini {
    height: 20px;
    padding: 0px 5px;
    line-height: 19px;
    margin: 0px 0 2px 0;
  }
  .set-tag {
    cursor: pointer;
    background: rgba(236, 236, 255, 1);
    // border: 1px solid rgba(236, 236, 255, 1) ;
    color: #6663ff;
    font-weight: bold;
  }
}
.questiontype {
  width: 400px;
  min-height: 100px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
}
.questiontype_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.questiontype_head_right {
  display: flex;
  align-items: center;
}
.questiontype_head_right_card {
  margin-left: 10px;
}
</style>
